import React from 'react';
import { Wrapper, Label, LightLabel } from './styled';
import { WsAddButton } from '../WSActionBar/components/LeftGroup';
import { useSelector } from 'react-redux';
import { selectNoResultsMessage } from 'store/Workspace/selectors';

const EmptyState = () => {
  const searchWithNoResults = useSelector(selectNoResultsMessage);
  if (searchWithNoResults) return <Wrapper><Label>{ searchWithNoResults }</Label></Wrapper>;
  return (
    <Wrapper>
      <Label>You currently have 0 Workspaces</Label>
      <LightLabel>Start by creating one</LightLabel>
      <WsAddButton />
    </Wrapper>
  );
};

export default EmptyState;
